import tw from 'twin.macro'
import { useContext } from 'react'
import { TableTagsSelect } from 'src/components/shared/table/TableTagsSelect'
import { TableSearch } from 'src/components/shared/table/TableSearch'
import { AssignContractorsTableContext } from '../AssignContractorsTable.context'

export const AssignContractorsHeader = () => {
  const { setSearchQuery, searchQuery, tagsFilter, setTagsFilter } = useContext(
    AssignContractorsTableContext,
  )

  return (
    <div
      css={tw`flex flex-row items-center justify-between px-4 py-3 bg-white border-0 border-b border-t border-solid border-[#EDEDED]`}
    >
      <div css={tw`flex flex-row items-center gap-2`}>
        <TableSearch
          searchQuery={searchQuery}
          onChangeSearchQuery={setSearchQuery}
          className="w-[284px]"
        />
        <TableTagsSelect selectedTags={tagsFilter} setSelectedTags={setTagsFilter} />
      </div>
    </div>
  )
}
